/**
 * @fileoverview Servicio para gestión del LocalStorage del curso
 * @description Maneja la persistencia de datos de curso en el navegador
 */

import { ICreateCurso } from '../types';

const CURSO_STORAGE_KEY = 'cg-seguros-curso';
const CURSO_ID_KEY = 'cg-seguros-curso-id';

/**
 * Servicio para gestión del LocalStorage del curso
 */
export const cursoStorage = {
  /**
   * Guarda los datos del curso en LocalStorage
   * @param curso - Datos del curso a guardar
   */
  saveCurso(curso: ICreateCurso): void {
    try {
      localStorage.setItem(CURSO_STORAGE_KEY, JSON.stringify(curso));
    } catch (error) {
      // Silently fail if localStorage is not available
    }
  },

  /**
   * Obtiene los datos del curso desde LocalStorage
   * @returns Datos del curso o null si no existen
   */
  getCurso(): ICreateCurso | null {
    try {
      const stored = localStorage.getItem(CURSO_STORAGE_KEY);
      if (stored) {
        const curso = JSON.parse(stored);
        // Convertir fechas de string a Date
        if (curso.fechaInicio) {
          curso.fechaInicio = new Date(curso.fechaInicio);
        }
        if (curso.fechaFin) {
          curso.fechaFin = new Date(curso.fechaFin);
        }
        return curso;
      }
      return null;
    } catch (error) {
      return null;
    }
  },

  /**
   * Limpia los datos del curso del LocalStorage
   */
  clearCurso(): void {
    try {
      localStorage.removeItem(CURSO_STORAGE_KEY);
      localStorage.removeItem(CURSO_ID_KEY);
    } catch (error) {
      // Silently fail if localStorage is not available
    }
  },

  /**
   * Verifica si existe un curso guardado
   * @returns true si existe un curso guardado
   */
  hasCurso(): boolean {
    return this.getCurso() !== null;
  },

  /**
   * Guarda el ID del curso en LocalStorage
   * @param id - ID del curso
   */
  saveCursoId(id: number): void {
    try {
      localStorage.setItem(CURSO_ID_KEY, JSON.stringify(id));
    } catch (error) {
      // Silently fail if localStorage is not available
    }
  },

  /**
   * Obtiene el ID del curso desde LocalStorage
   * @returns ID del curso o null si no existe
   */
  getCursoId(): number | null {
    try {
      const stored = localStorage.getItem(CURSO_ID_KEY);
      if (stored) {
        return JSON.parse(stored);
      }
      return null;
    } catch (error) {
      return null;
    }
  },

  /**
   * Limpia el ID del curso del LocalStorage
   */
  clearCursoId(): void {
    try {
      localStorage.removeItem(CURSO_ID_KEY);
    } catch (error) {
      // Silently fail if localStorage is not available
    }
  }
};

